import { Anchor } from "antd";

import "./ManualAnchor.css";

const ManualAnchor = () => {
  return (
    <Anchor
      className="manual-anchor"
      offsetTop={144}
      affix={{
        offsetTop: 124,
      }}
      items={[
        {
          key: "sync-workflow",
          href: "#sync-workflow",
          title: "流程",
        },
        {
          key: "connection-method",
          href: "#connection-method",
          title: "客戶端連線方式​",
        },
        {
          key: "mapping-fields",
          href: "#mapping-fields",
          title: "達易與客戶端資料對接",
          children: [
            {
              key: "dz-wo-logic",
              href: "#dz-wo-logic",
              title: "達易工單邏輯",
            },
            {
              key: "customer-wo-logic",
              href: "#customer-wo-logic",
              title: "客戶工單邏輯",
            },
            {
              key: "mapping-rule",
              href: "#mapping-rule",
              title: "對接規則",
            },
          ],
        },
        {
          key: "sync-conditions",
          href: "#sync-conditions",
          title: "同步條件",
          children: [
            {
              key: "work-order",
              href: "#work-order",
              title: "工單",
            },
            {
              key: "passive-import-item",
              href: "#passive-import-item",
              title: "被動匯入項目",
            },
          ],
        },
        {
          key: "update-conditions",
          href: "#update-conditions",
          title: "更新工單的條件與頻率​",
        },
      ]}
    />
  );
};

export default ManualAnchor;
